// Single source of truth for vertical spacing between checkbox / radio rows in
// MANUAL JSX. Both Checkbox.Group and Radio.Group (and the legacy Form/Radio)
// consume this, so the gap is defined once for the hand-written path.
//
// The declarative `Form` path (fields=[{type:'checkbox'}]) is a separate,
// margin-based rhythm system and does NOT use this constant — it spaces
// consecutive checkboxes via `mb-2!` in Form.js (FieldInner) and groups via
// FieldGroup's `gap-y-2`. All three resolve to the same Tailwind token `2`
// (8px). If you change the standard row gap, update all three to match:
//   - this constant (gap-2)
//   - Form.js `mb-2!` (isCheckboxFollowedByCheckbox)
//   - FieldGroup.js container `gap-y-2`
export const OPTION_GROUP_CLASSNAME = 'flex flex-col gap-2';
